<loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

<div class="cs-page-list-grid">
  <!-- Filters Panel -->
  @if (filterConfig() && showFilters()) {
    <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
  }

  <!-- Data Table Panel -->
  <p-panel [header]="'Completed_Dispatches' | translateWF: 'Completed Dispatches'">
    <ng-template pTemplate="icons">
      <p-button
        [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
        [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
        (click)="showFilters.set(!showFilters())"
        variant="outlined"
        size="small"
      />
    </ng-template>
    <p-card data-variant="compact">
      <p-table [value]="dispatchList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTableSort($event)">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 120px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
            <th pSortableColumn="number">
              {{ 'Dispatch_Request_Number' | translateWF: 'DR Number' }}
              <p-sortIcon field="number"></p-sortIcon>
            </th>
            <th>{{ 'Dispatch_Request_Date_Created' | translateWF: 'Date Created' }}</th>
            <th>{{ 'Dispatch_Request_Status' | translateWF: 'Status' }}</th>
            <th>{{ 'Dispatch_Request_Location' | translateWF: 'Location' }}</th>
            <th>{{ 'Supply_Request_Number' | translateWF: 'Supply Request Number' }}</th>
            <th>{{ 'Common_Department' | translateWF: 'Department' }}</th>
            <th>{{ 'Dispatch_Request_Completed_Date' | translateWF: 'Completed Date' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-dispatchRequest>
          <tr class="cursor-pointer">
            <td>
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                severity="info"
                (click)="navigateToDetail(dispatchRequest.id)"
                pTooltip="{{ 'Common_View_Details' | translateWF: 'View Details (Read-Only)' }}"
                tooltipPosition="top"
              />
              @if (canCreateInternalReturn) {
                <p-button
                  icon="pi pi-undo"
                  [rounded]="true"
                  [text]="true"
                  severity="warn"
                  (click)="navigateToInternalReturn(dispatchRequest.id)"
                  pTooltip="{{ 'Create_Return' | translateWF: 'Create Return' }}"
                  tooltipPosition="top"
                />
              }
            </td>
            <td>{{ dispatchRequest.number }}</td>
            <td>{{ dispatchRequest.createdDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-6' }}</td>
            <td>
              <p-tag [value]="getStatusLabel(dispatchRequest.status)" [severity]="getStatusSeverity(dispatchRequest.status)" />
            </td>
            <td>{{ localHelperService.getLocalizedValue(dispatchRequest.locationName) || dispatchRequest.locationCode }}</td>
            <td>{{ dispatchRequest.supplyRequestNumber || '-' }}</td>
            <td>{{ getDepartmentName(dispatchRequest.departmentReference) }}</td>
            <td>{{ dispatchRequest.modifiedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-6' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="text-center">
              {{ 'Dispatch_Request_No_Completed_Found' | translateWF: 'No completed dispatch requests found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [first]="(currentPage - 1) * pageSize"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[15, 25, 50, 100]"
        dropdownAppendTo="body"
        class="mt-4"
      ></p-paginator>
    </p-card>
  </p-panel>
</div>
